// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FF_LocalPreviewAlerts_localPreviewAlerts_ZhPss {
  top: 7.25rem;
  left: 0;
  right: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"localPreviewAlerts": `FF_LocalPreviewAlerts_localPreviewAlerts_ZhPss`
};
export default ___CSS_LOADER_EXPORT___;
